import { jsx as r, jsxs as $ } from "react/jsx-runtime";
import { useState as x, useCallback as v, useMemo as h } from "react";
import t from "./styles.module.less.js";
import C from "./chevron-down.svg.js";
const H = (u) => {
  const {
    items: e,
    classNames: n,
    singleOpen: f = !1,
    useExternalOpenIndex: i = !1,
    openExternalIndex: d = null,
    setOpenExternalIndex: O,
    defaultOpenIndex: p = 0
  } = u;
  if (f) {
    const [o, c] = x(
      i ? null : p
    ), I = i ? d : o, l = i ? O : c;
    return /* @__PURE__ */ r("div", { className: `${t.accordionContainer} ${(n == null ? void 0 : n.container) ?? ""}`, children: e.map((s, a) => {
      const m = I === a;
      return /* @__PURE__ */ r(
        g,
        {
          item: s,
          classNames: n,
          controlledIsOpen: m ?? !1,
          onToggle: () => {
            l && l(m ? null : a);
          }
        },
        s.title ?? a
      );
    }) });
  }
  return /* @__PURE__ */ r("div", { className: `${t.accordionContainer} ${(n == null ? void 0 : n.container) ?? ""}`, children: e.map((o, c) => /* @__PURE__ */ r(
    g,
    {
      item: o,
      classNames: n,
      defaultOpen: c === (p ?? -1)
    },
    o.title ?? c
  )) });
}, g = (u) => {
  const { item: e, classNames: n, defaultOpen: f = !1, controlledIsOpen: i, onToggle: d } = u, [O, p] = x(f), o = i ?? O, c = v(() => {
    if (d) {
      d();
      return;
    }
    p((l) => !l);
  }, [d]), I = h(() => typeof e.content != "string" ? null : e.replaceItems ? Object.entries(e.replaceItems).reduce((l, [s, a]) => l.replace(s, a), e.content) : e.content, [e]);
  return /* @__PURE__ */ $("div", { className: `${t.accordionRow} ${o ? t.open : ""} ${(n == null ? void 0 : n.row) ?? ""}`, children: [
    /* @__PURE__ */ $("div", { className: t.accordionHeader, onClick: c, children: [
      /* @__PURE__ */ r("div", { className: `${t.accordionTitle} ${(n == null ? void 0 : n.title) ?? ""}`, children: e.title }),
      /* @__PURE__ */ r(
        C,
        {
          className: `${t.accordionIcon} ${o ? t.rotated : ""}`
        }
      )
    ] }),
    /* @__PURE__ */ r("div", { className: `${t.accordionContent} ${o ? t.open : ""} ${(n == null ? void 0 : n.content) ?? ""}`, children: typeof e.content == "string" ? /* @__PURE__ */ r("div", { dangerouslySetInnerHTML: { __html: I ?? "" } }) : e.content })
  ] });
};
export {
  H as Accordion
};
